export default {
  title: 'Produtos',
  buttons: {
    add_product: 'Adicionar produto',
  },
  modals: {
    delete_product: {
      title: 'Tem a certeza',
      description:
        'Todas as subscrições atuais com este produto permanecerão ativas, mas não será possível criar novas subscrições com ele. Esta ação não pode ser desfeita!',
    },
    delete_price: {
      title: 'Tem a certeza',
      description:
        'Todas as subscrições atuais com este preço permanecerão ativas, mas não será possível criar novas subscrições com ele. Esta ação não pode ser desfeita!',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_delete_product: 'Falha ao eliminar o produto',
    product_got_deleted: 'Produto eliminado',
    failed_to_delete_price: 'Falha ao eliminar o preço',
    price_got_deleted: 'Preço eliminado',
  },
};
